import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d28ebf5e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d28ebf5e&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d28ebf5e')) {
      api.createRecord('d28ebf5e', component.options)
    } else {
      api.reload('d28ebf5e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d28ebf5e&", function () {
      api.rerender('d28ebf5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CScreenshots/index.vue"
export default component.exports